
export default class Regex {

    #regexp

    constructor (regexp) {
        this.#regexp = regexp;
        Object.freeze(this);
    }

    static of (stringExpression, modifiers) {
        return new Regex(new RegExp(stringExpression, modifiers));
    }

    match (text) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#specifying_a_string_as_the_replacement
        return text.replace(this.#regexp, "<span>$&</span>");
    }

}
